import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Link } from "@mui/material";
import { Modal, Button } from 'react-bootstrap';
import { sendAPIRequest, displayNotification } from "helpers";
import moment from "moment";
import { useTranslation } from "react-i18next";

function PipelinePopup({ schedule }) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (schedule && schedule.is_active === true) {
      const today = new Date().toISOString().split("T")[0];
      const isHidden = localStorage.getItem("hidePipelinePopup") === today;
      if (!isHidden) {
        setIsOpen(true);
      }
    }
  }, [schedule]);

  const handleDontShowToday = () => {
    const today = new Date().toISOString().split("T")[0];
    localStorage.setItem("hidePipelinePopup", today);
    setIsOpen(false);
  };

  return (
    <>
      {schedule && (
        <Modal show={isOpen} onHide={() => setIsOpen(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{t("-1", "Scheduled System Maintainance Notice")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              {t("-1", "Site will be under maintenance from")}{" "}
              <strong>
                {moment(schedule.run_date_time).format("YYYY-MM-DD hh:mm A")}{" "}
                {t("-1", "to")}{" "}
                {moment(schedule.expected_end_date_time).format("YYYY-MM-DD hh:mm A")}{" "}
                {t("-1", "under [UTC±00:00]")}
              </strong>
            </p>

            <div
              dangerouslySetInnerHTML={{ __html: schedule.message }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Link
              className="cursor-pointer"
              onClick={handleDontShowToday}
            >
              {t("-1", "Don't show again today")}
            </Link>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );

}

export default PipelinePopup;